var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "color": "grey lighten-4",
      "elevation": "0"
    }
  }, 'v-card', {
    class: {
      'px-12 py-8': !_vm.$vuetify.breakpoint.mobile
    }
  }, false), [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text",
    class: {
      'justify-center': _vm.$vuetify.breakpoint.mobile
    }
  }, [_vm._v(" 교환권 번호 ")]), _c('v-card-text', [_c('v-row', {
    staticClass: "row--small"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item.tempId,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', [_c('v-text-field', _vm._b({
      attrs: {
        "flat": "",
        "dense": "",
        "solo": "",
        "hide-details": "",
        "placeholder": "교환권 번호를 입력해주세요.",
        "clearable": ""
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.prev,
        callback: function callback($$v) {
          _vm.$set(item, "prev", $$v);
        },
        expression: "item.prev"
      }
    }, 'v-text-field', {
      class: {
        'text-center': _vm.$vuetify.breakpoint.mobile
      }
    }, false))], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', _vm._b({
      staticStyle: {
        "background": "transparent !important"
      },
      attrs: {
        "icon": "",
        "tile": ""
      },
      on: {
        "click": function click($event) {
          return _vm.pull(item);
        }
      }
    }, 'v-btn', {
      disabled: _vm.items.length == 1
    }, false), [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1)], 1)];
  }), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "x-large": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": _vm.push
    }
  }, 'v-btn', {
    disabled: _vm.items.length == 10
  }, false), [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 입력란 추가 ")]), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }